<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-02-14 15:15:36
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-06-28 12:01:23
 * @FilePath: \community-backende:\sns-user-frontend\src\components\pageStatus.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-status">
    <svg-icon v-if="!custom" :name="`icon-${props.status}-${brandName}${isDark}`" />
    <svg-icon v-else :name="status"/>
    <span>{{ content || $t(props.status)}}</span>
    <p v-if="retry" class="retry" @click="retryCallback">{{ $t('retry') }}</p>
  </div>
</template>

<script setup>

import { ref, computed } from 'vue'

const props = defineProps({
  status: {
    type: String,
  },
  content: {
    type: String,
    default: ''
  },
  custom: {
    type: Boolean,
    default: false
  },
  retry: {
    type: Boolean,
    default: false
  },
  retryCallback: {
    type: Function,
    default: null
  },
})

const isDark = computed(() => {
  return document.body.className.includes('dark') ? '_dark' : ''
})


const brandName = ref(import.meta.env.VITE_BRAND.toLowerCase())
</script>

<style lang="postcss" scoped>
.page-status {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  padding: 8% 0 4%;
}
.svg-icon {
  width: 312px;
  height: 210px;
}
span {
  font-size: 20px;
  color: var(--text-hint);
}
.retry {
  font-size: 14px;
  margin-top: 10px;
  color: #DF3D3D;
  cursor: pointer;
}
@media (max-width: 1023px) {
  .page-status {
    padding: 84px 20px 40px;
    box-sizing: border-box;
    margin: 0;
  }
  .svg-icon {
    width: 100%;
  }
  span {
    font-size: 16px;
  }
}
</style>